/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var extproto_ext_pb = require('../../../../../../../../../../extproto/ext_pb.js');
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
var validate_validate_pb = require('../../../../../../../../../../validate/validate_pb.js');
var github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_route_v3_route_components_pb = require('../../../../../../../../../../github.com/solo-io/solo-apis/api/gloo/gloo/external/envoy/config/route/v3/route_components_pb.js');
var github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_type_matcher_v3_string_pb = require('../../../../../../../../../../github.com/solo-io/solo-apis/api/gloo/gloo/external/envoy/type/matcher/v3/string_pb.js');
var github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_core_v3_extension_pb = require('../../../../../../../../../../github.com/solo-io/solo-apis/api/gloo/gloo/external/envoy/config/core/v3/extension_pb.js');
goog.exportSymbol('proto.envoy.api.v2.filter.http.Extraction', null, global);
goog.exportSymbol('proto.envoy.api.v2.filter.http.FilterTransformations', null, global);
goog.exportSymbol('proto.envoy.api.v2.filter.http.HeaderBodyTransform', null, global);
goog.exportSymbol('proto.envoy.api.v2.filter.http.InjaTemplate', null, global);
goog.exportSymbol('proto.envoy.api.v2.filter.http.MergeExtractorsToBody', null, global);
goog.exportSymbol('proto.envoy.api.v2.filter.http.Passthrough', null, global);
goog.exportSymbol('proto.envoy.api.v2.filter.http.ResponseMatcher', null, global);
goog.exportSymbol('proto.envoy.api.v2.filter.http.ResponseTransformationRule', null, global);
goog.exportSymbol('proto.envoy.api.v2.filter.http.RouteTransformations', null, global);
goog.exportSymbol('proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation', null, global);
goog.exportSymbol('proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch', null, global);
goog.exportSymbol('proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch', null, global);
goog.exportSymbol('proto.envoy.api.v2.filter.http.Transformation', null, global);
goog.exportSymbol('proto.envoy.api.v2.filter.http.TransformationRule', null, global);
goog.exportSymbol('proto.envoy.api.v2.filter.http.TransformationRule.Transformations', null, global);
goog.exportSymbol('proto.envoy.api.v2.filter.http.TransformationTemplate', null, global);
goog.exportSymbol('proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue', null, global);
goog.exportSymbol('proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend', null, global);
goog.exportSymbol('proto.envoy.api.v2.filter.http.TransformationTemplate.RequestBodyParse', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.api.v2.filter.http.FilterTransformations = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.envoy.api.v2.filter.http.FilterTransformations.repeatedFields_, null);
};
goog.inherits(proto.envoy.api.v2.filter.http.FilterTransformations, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.api.v2.filter.http.FilterTransformations.displayName = 'proto.envoy.api.v2.filter.http.FilterTransformations';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.envoy.api.v2.filter.http.FilterTransformations.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.api.v2.filter.http.FilterTransformations.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.api.v2.filter.http.FilterTransformations.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.api.v2.filter.http.FilterTransformations} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.FilterTransformations.toObject = function(includeInstance, msg) {
  var f, obj = {
    transformationsList: jspb.Message.toObjectList(msg.getTransformationsList(),
    proto.envoy.api.v2.filter.http.TransformationRule.toObject, includeInstance),
    stage: jspb.Message.getFieldWithDefault(msg, 2, 0),
    logRequestResponseInfo: jspb.Message.getFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.api.v2.filter.http.FilterTransformations}
 */
proto.envoy.api.v2.filter.http.FilterTransformations.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.api.v2.filter.http.FilterTransformations;
  return proto.envoy.api.v2.filter.http.FilterTransformations.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.api.v2.filter.http.FilterTransformations} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.api.v2.filter.http.FilterTransformations}
 */
proto.envoy.api.v2.filter.http.FilterTransformations.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.envoy.api.v2.filter.http.TransformationRule;
      reader.readMessage(value,proto.envoy.api.v2.filter.http.TransformationRule.deserializeBinaryFromReader);
      msg.addTransformations(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStage(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLogRequestResponseInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.api.v2.filter.http.FilterTransformations.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.api.v2.filter.http.FilterTransformations.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.api.v2.filter.http.FilterTransformations} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.FilterTransformations.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransformationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.envoy.api.v2.filter.http.TransformationRule.serializeBinaryToWriter
    );
  }
  f = message.getStage();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getLogRequestResponseInfo();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * repeated TransformationRule transformations = 1;
 * @return {!Array<!proto.envoy.api.v2.filter.http.TransformationRule>}
 */
proto.envoy.api.v2.filter.http.FilterTransformations.prototype.getTransformationsList = function() {
  return /** @type{!Array<!proto.envoy.api.v2.filter.http.TransformationRule>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.envoy.api.v2.filter.http.TransformationRule, 1));
};


/** @param {!Array<!proto.envoy.api.v2.filter.http.TransformationRule>} value */
proto.envoy.api.v2.filter.http.FilterTransformations.prototype.setTransformationsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.envoy.api.v2.filter.http.TransformationRule=} opt_value
 * @param {number=} opt_index
 * @return {!proto.envoy.api.v2.filter.http.TransformationRule}
 */
proto.envoy.api.v2.filter.http.FilterTransformations.prototype.addTransformations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.envoy.api.v2.filter.http.TransformationRule, opt_index);
};


proto.envoy.api.v2.filter.http.FilterTransformations.prototype.clearTransformationsList = function() {
  this.setTransformationsList([]);
};


/**
 * optional uint32 stage = 2;
 * @return {number}
 */
proto.envoy.api.v2.filter.http.FilterTransformations.prototype.getStage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.envoy.api.v2.filter.http.FilterTransformations.prototype.setStage = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool log_request_response_info = 3;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.envoy.api.v2.filter.http.FilterTransformations.prototype.getLogRequestResponseInfo = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 3, false));
};


/** @param {boolean} value */
proto.envoy.api.v2.filter.http.FilterTransformations.prototype.setLogRequestResponseInfo = function(value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.api.v2.filter.http.TransformationRule = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.envoy.api.v2.filter.http.TransformationRule, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.api.v2.filter.http.TransformationRule.displayName = 'proto.envoy.api.v2.filter.http.TransformationRule';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.api.v2.filter.http.TransformationRule.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.api.v2.filter.http.TransformationRule.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.api.v2.filter.http.TransformationRule} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.TransformationRule.toObject = function(includeInstance, msg) {
  var f, obj = {
    match: (f = msg.getMatch()) && github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_route_v3_route_components_pb.RouteMatch.toObject(includeInstance, f),
    routeTransformations: (f = msg.getRouteTransformations()) && proto.envoy.api.v2.filter.http.TransformationRule.Transformations.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.api.v2.filter.http.TransformationRule}
 */
proto.envoy.api.v2.filter.http.TransformationRule.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.api.v2.filter.http.TransformationRule;
  return proto.envoy.api.v2.filter.http.TransformationRule.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.api.v2.filter.http.TransformationRule} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.api.v2.filter.http.TransformationRule}
 */
proto.envoy.api.v2.filter.http.TransformationRule.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_route_v3_route_components_pb.RouteMatch;
      reader.readMessage(value,github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_route_v3_route_components_pb.RouteMatch.deserializeBinaryFromReader);
      msg.setMatch(value);
      break;
    case 2:
      var value = new proto.envoy.api.v2.filter.http.TransformationRule.Transformations;
      reader.readMessage(value,proto.envoy.api.v2.filter.http.TransformationRule.Transformations.deserializeBinaryFromReader);
      msg.setRouteTransformations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.api.v2.filter.http.TransformationRule.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.api.v2.filter.http.TransformationRule.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.api.v2.filter.http.TransformationRule} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.TransformationRule.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMatch();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_route_v3_route_components_pb.RouteMatch.serializeBinaryToWriter
    );
  }
  f = message.getRouteTransformations();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.envoy.api.v2.filter.http.TransformationRule.Transformations.serializeBinaryToWriter
    );
  }
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.api.v2.filter.http.TransformationRule.Transformations = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.envoy.api.v2.filter.http.TransformationRule.Transformations, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.api.v2.filter.http.TransformationRule.Transformations.displayName = 'proto.envoy.api.v2.filter.http.TransformationRule.Transformations';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.api.v2.filter.http.TransformationRule.Transformations.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.api.v2.filter.http.TransformationRule.Transformations.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.api.v2.filter.http.TransformationRule.Transformations} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.TransformationRule.Transformations.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestTransformation: (f = msg.getRequestTransformation()) && proto.envoy.api.v2.filter.http.Transformation.toObject(includeInstance, f),
    clearRouteCache: jspb.Message.getFieldWithDefault(msg, 3, false),
    responseTransformation: (f = msg.getResponseTransformation()) && proto.envoy.api.v2.filter.http.Transformation.toObject(includeInstance, f),
    onStreamCompletionTransformation: (f = msg.getOnStreamCompletionTransformation()) && proto.envoy.api.v2.filter.http.Transformation.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.api.v2.filter.http.TransformationRule.Transformations}
 */
proto.envoy.api.v2.filter.http.TransformationRule.Transformations.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.api.v2.filter.http.TransformationRule.Transformations;
  return proto.envoy.api.v2.filter.http.TransformationRule.Transformations.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.api.v2.filter.http.TransformationRule.Transformations} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.api.v2.filter.http.TransformationRule.Transformations}
 */
proto.envoy.api.v2.filter.http.TransformationRule.Transformations.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.envoy.api.v2.filter.http.Transformation;
      reader.readMessage(value,proto.envoy.api.v2.filter.http.Transformation.deserializeBinaryFromReader);
      msg.setRequestTransformation(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setClearRouteCache(value);
      break;
    case 2:
      var value = new proto.envoy.api.v2.filter.http.Transformation;
      reader.readMessage(value,proto.envoy.api.v2.filter.http.Transformation.deserializeBinaryFromReader);
      msg.setResponseTransformation(value);
      break;
    case 4:
      var value = new proto.envoy.api.v2.filter.http.Transformation;
      reader.readMessage(value,proto.envoy.api.v2.filter.http.Transformation.deserializeBinaryFromReader);
      msg.setOnStreamCompletionTransformation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.api.v2.filter.http.TransformationRule.Transformations.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.api.v2.filter.http.TransformationRule.Transformations.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.api.v2.filter.http.TransformationRule.Transformations} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.TransformationRule.Transformations.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestTransformation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.envoy.api.v2.filter.http.Transformation.serializeBinaryToWriter
    );
  }
  f = message.getClearRouteCache();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getResponseTransformation();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.envoy.api.v2.filter.http.Transformation.serializeBinaryToWriter
    );
  }
  f = message.getOnStreamCompletionTransformation();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.envoy.api.v2.filter.http.Transformation.serializeBinaryToWriter
    );
  }
};


/**
 * optional Transformation request_transformation = 1;
 * @return {?proto.envoy.api.v2.filter.http.Transformation}
 */
proto.envoy.api.v2.filter.http.TransformationRule.Transformations.prototype.getRequestTransformation = function() {
  return /** @type{?proto.envoy.api.v2.filter.http.Transformation} */ (
    jspb.Message.getWrapperField(this, proto.envoy.api.v2.filter.http.Transformation, 1));
};


/** @param {?proto.envoy.api.v2.filter.http.Transformation|undefined} value */
proto.envoy.api.v2.filter.http.TransformationRule.Transformations.prototype.setRequestTransformation = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.envoy.api.v2.filter.http.TransformationRule.Transformations.prototype.clearRequestTransformation = function() {
  this.setRequestTransformation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.TransformationRule.Transformations.prototype.hasRequestTransformation = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool clear_route_cache = 3;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.envoy.api.v2.filter.http.TransformationRule.Transformations.prototype.getClearRouteCache = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 3, false));
};


/** @param {boolean} value */
proto.envoy.api.v2.filter.http.TransformationRule.Transformations.prototype.setClearRouteCache = function(value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional Transformation response_transformation = 2;
 * @return {?proto.envoy.api.v2.filter.http.Transformation}
 */
proto.envoy.api.v2.filter.http.TransformationRule.Transformations.prototype.getResponseTransformation = function() {
  return /** @type{?proto.envoy.api.v2.filter.http.Transformation} */ (
    jspb.Message.getWrapperField(this, proto.envoy.api.v2.filter.http.Transformation, 2));
};


/** @param {?proto.envoy.api.v2.filter.http.Transformation|undefined} value */
proto.envoy.api.v2.filter.http.TransformationRule.Transformations.prototype.setResponseTransformation = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.envoy.api.v2.filter.http.TransformationRule.Transformations.prototype.clearResponseTransformation = function() {
  this.setResponseTransformation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.TransformationRule.Transformations.prototype.hasResponseTransformation = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Transformation on_stream_completion_transformation = 4;
 * @return {?proto.envoy.api.v2.filter.http.Transformation}
 */
proto.envoy.api.v2.filter.http.TransformationRule.Transformations.prototype.getOnStreamCompletionTransformation = function() {
  return /** @type{?proto.envoy.api.v2.filter.http.Transformation} */ (
    jspb.Message.getWrapperField(this, proto.envoy.api.v2.filter.http.Transformation, 4));
};


/** @param {?proto.envoy.api.v2.filter.http.Transformation|undefined} value */
proto.envoy.api.v2.filter.http.TransformationRule.Transformations.prototype.setOnStreamCompletionTransformation = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


proto.envoy.api.v2.filter.http.TransformationRule.Transformations.prototype.clearOnStreamCompletionTransformation = function() {
  this.setOnStreamCompletionTransformation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.TransformationRule.Transformations.prototype.hasOnStreamCompletionTransformation = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional solo.io.envoy.config.route.v3.RouteMatch match = 1;
 * @return {?proto.solo.io.envoy.config.route.v3.RouteMatch}
 */
proto.envoy.api.v2.filter.http.TransformationRule.prototype.getMatch = function() {
  return /** @type{?proto.solo.io.envoy.config.route.v3.RouteMatch} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_route_v3_route_components_pb.RouteMatch, 1));
};


/** @param {?proto.solo.io.envoy.config.route.v3.RouteMatch|undefined} value */
proto.envoy.api.v2.filter.http.TransformationRule.prototype.setMatch = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.envoy.api.v2.filter.http.TransformationRule.prototype.clearMatch = function() {
  this.setMatch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.TransformationRule.prototype.hasMatch = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Transformations route_transformations = 2;
 * @return {?proto.envoy.api.v2.filter.http.TransformationRule.Transformations}
 */
proto.envoy.api.v2.filter.http.TransformationRule.prototype.getRouteTransformations = function() {
  return /** @type{?proto.envoy.api.v2.filter.http.TransformationRule.Transformations} */ (
    jspb.Message.getWrapperField(this, proto.envoy.api.v2.filter.http.TransformationRule.Transformations, 2));
};


/** @param {?proto.envoy.api.v2.filter.http.TransformationRule.Transformations|undefined} value */
proto.envoy.api.v2.filter.http.TransformationRule.prototype.setRouteTransformations = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.envoy.api.v2.filter.http.TransformationRule.prototype.clearRouteTransformations = function() {
  this.setRouteTransformations(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.TransformationRule.prototype.hasRouteTransformations = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.api.v2.filter.http.RouteTransformations = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.envoy.api.v2.filter.http.RouteTransformations.repeatedFields_, null);
};
goog.inherits(proto.envoy.api.v2.filter.http.RouteTransformations, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.api.v2.filter.http.RouteTransformations.displayName = 'proto.envoy.api.v2.filter.http.RouteTransformations';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.envoy.api.v2.filter.http.RouteTransformations.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.api.v2.filter.http.RouteTransformations.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.api.v2.filter.http.RouteTransformations} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.RouteTransformations.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestTransformation: (f = msg.getRequestTransformation()) && proto.envoy.api.v2.filter.http.Transformation.toObject(includeInstance, f),
    responseTransformation: (f = msg.getResponseTransformation()) && proto.envoy.api.v2.filter.http.Transformation.toObject(includeInstance, f),
    clearRouteCache: jspb.Message.getFieldWithDefault(msg, 3, false),
    transformationsList: jspb.Message.toObjectList(msg.getTransformationsList(),
    proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.api.v2.filter.http.RouteTransformations}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.api.v2.filter.http.RouteTransformations;
  return proto.envoy.api.v2.filter.http.RouteTransformations.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.api.v2.filter.http.RouteTransformations} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.api.v2.filter.http.RouteTransformations}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.envoy.api.v2.filter.http.Transformation;
      reader.readMessage(value,proto.envoy.api.v2.filter.http.Transformation.deserializeBinaryFromReader);
      msg.setRequestTransformation(value);
      break;
    case 2:
      var value = new proto.envoy.api.v2.filter.http.Transformation;
      reader.readMessage(value,proto.envoy.api.v2.filter.http.Transformation.deserializeBinaryFromReader);
      msg.setResponseTransformation(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setClearRouteCache(value);
      break;
    case 4:
      var value = new proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation;
      reader.readMessage(value,proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.deserializeBinaryFromReader);
      msg.addTransformations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.api.v2.filter.http.RouteTransformations.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.api.v2.filter.http.RouteTransformations} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.RouteTransformations.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestTransformation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.envoy.api.v2.filter.http.Transformation.serializeBinaryToWriter
    );
  }
  f = message.getResponseTransformation();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.envoy.api.v2.filter.http.Transformation.serializeBinaryToWriter
    );
  }
  f = message.getClearRouteCache();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getTransformationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.serializeBinaryToWriter
    );
  }
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.oneofGroups_);
};
goog.inherits(proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.displayName = 'proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.MatchCase = {
  MATCH_NOT_SET: 0,
  REQUEST_MATCH: 2,
  RESPONSE_MATCH: 3
};

/**
 * @return {proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.MatchCase}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.prototype.getMatchCase = function() {
  return /** @type {proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.MatchCase} */(jspb.Message.computeOneofCase(this, proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.toObject = function(includeInstance, msg) {
  var f, obj = {
    stage: jspb.Message.getFieldWithDefault(msg, 1, 0),
    requestMatch: (f = msg.getRequestMatch()) && proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.toObject(includeInstance, f),
    responseMatch: (f = msg.getResponseMatch()) && proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation;
  return proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStage(value);
      break;
    case 2:
      var value = new proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch;
      reader.readMessage(value,proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.deserializeBinaryFromReader);
      msg.setRequestMatch(value);
      break;
    case 3:
      var value = new proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch;
      reader.readMessage(value,proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch.deserializeBinaryFromReader);
      msg.setResponseMatch(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStage();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getRequestMatch();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.serializeBinaryToWriter
    );
  }
  f = message.getResponseMatch();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch.serializeBinaryToWriter
    );
  }
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.displayName = 'proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.toObject = function(includeInstance, msg) {
  var f, obj = {
    match: (f = msg.getMatch()) && github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_route_v3_route_components_pb.RouteMatch.toObject(includeInstance, f),
    requestTransformation: (f = msg.getRequestTransformation()) && proto.envoy.api.v2.filter.http.Transformation.toObject(includeInstance, f),
    responseTransformation: (f = msg.getResponseTransformation()) && proto.envoy.api.v2.filter.http.Transformation.toObject(includeInstance, f),
    clearRouteCache: jspb.Message.getFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch;
  return proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_route_v3_route_components_pb.RouteMatch;
      reader.readMessage(value,github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_route_v3_route_components_pb.RouteMatch.deserializeBinaryFromReader);
      msg.setMatch(value);
      break;
    case 2:
      var value = new proto.envoy.api.v2.filter.http.Transformation;
      reader.readMessage(value,proto.envoy.api.v2.filter.http.Transformation.deserializeBinaryFromReader);
      msg.setRequestTransformation(value);
      break;
    case 3:
      var value = new proto.envoy.api.v2.filter.http.Transformation;
      reader.readMessage(value,proto.envoy.api.v2.filter.http.Transformation.deserializeBinaryFromReader);
      msg.setResponseTransformation(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setClearRouteCache(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMatch();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_route_v3_route_components_pb.RouteMatch.serializeBinaryToWriter
    );
  }
  f = message.getRequestTransformation();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.envoy.api.v2.filter.http.Transformation.serializeBinaryToWriter
    );
  }
  f = message.getResponseTransformation();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.envoy.api.v2.filter.http.Transformation.serializeBinaryToWriter
    );
  }
  f = message.getClearRouteCache();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional solo.io.envoy.config.route.v3.RouteMatch match = 1;
 * @return {?proto.solo.io.envoy.config.route.v3.RouteMatch}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.prototype.getMatch = function() {
  return /** @type{?proto.solo.io.envoy.config.route.v3.RouteMatch} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_route_v3_route_components_pb.RouteMatch, 1));
};


/** @param {?proto.solo.io.envoy.config.route.v3.RouteMatch|undefined} value */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.prototype.setMatch = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.prototype.clearMatch = function() {
  this.setMatch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.prototype.hasMatch = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Transformation request_transformation = 2;
 * @return {?proto.envoy.api.v2.filter.http.Transformation}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.prototype.getRequestTransformation = function() {
  return /** @type{?proto.envoy.api.v2.filter.http.Transformation} */ (
    jspb.Message.getWrapperField(this, proto.envoy.api.v2.filter.http.Transformation, 2));
};


/** @param {?proto.envoy.api.v2.filter.http.Transformation|undefined} value */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.prototype.setRequestTransformation = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.prototype.clearRequestTransformation = function() {
  this.setRequestTransformation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.prototype.hasRequestTransformation = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Transformation response_transformation = 3;
 * @return {?proto.envoy.api.v2.filter.http.Transformation}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.prototype.getResponseTransformation = function() {
  return /** @type{?proto.envoy.api.v2.filter.http.Transformation} */ (
    jspb.Message.getWrapperField(this, proto.envoy.api.v2.filter.http.Transformation, 3));
};


/** @param {?proto.envoy.api.v2.filter.http.Transformation|undefined} value */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.prototype.setResponseTransformation = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.prototype.clearResponseTransformation = function() {
  this.setResponseTransformation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.prototype.hasResponseTransformation = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool clear_route_cache = 4;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.prototype.getClearRouteCache = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 4, false));
};


/** @param {boolean} value */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch.prototype.setClearRouteCache = function(value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch.displayName = 'proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch.toObject = function(includeInstance, msg) {
  var f, obj = {
    match: (f = msg.getMatch()) && proto.envoy.api.v2.filter.http.ResponseMatcher.toObject(includeInstance, f),
    responseTransformation: (f = msg.getResponseTransformation()) && proto.envoy.api.v2.filter.http.Transformation.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch;
  return proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.envoy.api.v2.filter.http.ResponseMatcher;
      reader.readMessage(value,proto.envoy.api.v2.filter.http.ResponseMatcher.deserializeBinaryFromReader);
      msg.setMatch(value);
      break;
    case 2:
      var value = new proto.envoy.api.v2.filter.http.Transformation;
      reader.readMessage(value,proto.envoy.api.v2.filter.http.Transformation.deserializeBinaryFromReader);
      msg.setResponseTransformation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMatch();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.envoy.api.v2.filter.http.ResponseMatcher.serializeBinaryToWriter
    );
  }
  f = message.getResponseTransformation();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.envoy.api.v2.filter.http.Transformation.serializeBinaryToWriter
    );
  }
};


/**
 * optional ResponseMatcher match = 1;
 * @return {?proto.envoy.api.v2.filter.http.ResponseMatcher}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch.prototype.getMatch = function() {
  return /** @type{?proto.envoy.api.v2.filter.http.ResponseMatcher} */ (
    jspb.Message.getWrapperField(this, proto.envoy.api.v2.filter.http.ResponseMatcher, 1));
};


/** @param {?proto.envoy.api.v2.filter.http.ResponseMatcher|undefined} value */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch.prototype.setMatch = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch.prototype.clearMatch = function() {
  this.setMatch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch.prototype.hasMatch = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Transformation response_transformation = 2;
 * @return {?proto.envoy.api.v2.filter.http.Transformation}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch.prototype.getResponseTransformation = function() {
  return /** @type{?proto.envoy.api.v2.filter.http.Transformation} */ (
    jspb.Message.getWrapperField(this, proto.envoy.api.v2.filter.http.Transformation, 2));
};


/** @param {?proto.envoy.api.v2.filter.http.Transformation|undefined} value */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch.prototype.setResponseTransformation = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch.prototype.clearResponseTransformation = function() {
  this.setResponseTransformation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch.prototype.hasResponseTransformation = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional uint32 stage = 1;
 * @return {number}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.prototype.getStage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.prototype.setStage = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional RequestMatch request_match = 2;
 * @return {?proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.prototype.getRequestMatch = function() {
  return /** @type{?proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch} */ (
    jspb.Message.getWrapperField(this, proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch, 2));
};


/** @param {?proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.RequestMatch|undefined} value */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.prototype.setRequestMatch = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.oneofGroups_[0], value);
};


proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.prototype.clearRequestMatch = function() {
  this.setRequestMatch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.prototype.hasRequestMatch = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ResponseMatch response_match = 3;
 * @return {?proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.prototype.getResponseMatch = function() {
  return /** @type{?proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch} */ (
    jspb.Message.getWrapperField(this, proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch, 3));
};


/** @param {?proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.ResponseMatch|undefined} value */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.prototype.setResponseMatch = function(value) {
  jspb.Message.setOneofWrapperField(this, 3, proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.oneofGroups_[0], value);
};


proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.prototype.clearResponseMatch = function() {
  this.setResponseMatch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation.prototype.hasResponseMatch = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Transformation request_transformation = 1;
 * @return {?proto.envoy.api.v2.filter.http.Transformation}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.prototype.getRequestTransformation = function() {
  return /** @type{?proto.envoy.api.v2.filter.http.Transformation} */ (
    jspb.Message.getWrapperField(this, proto.envoy.api.v2.filter.http.Transformation, 1));
};


/** @param {?proto.envoy.api.v2.filter.http.Transformation|undefined} value */
proto.envoy.api.v2.filter.http.RouteTransformations.prototype.setRequestTransformation = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.envoy.api.v2.filter.http.RouteTransformations.prototype.clearRequestTransformation = function() {
  this.setRequestTransformation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.prototype.hasRequestTransformation = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Transformation response_transformation = 2;
 * @return {?proto.envoy.api.v2.filter.http.Transformation}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.prototype.getResponseTransformation = function() {
  return /** @type{?proto.envoy.api.v2.filter.http.Transformation} */ (
    jspb.Message.getWrapperField(this, proto.envoy.api.v2.filter.http.Transformation, 2));
};


/** @param {?proto.envoy.api.v2.filter.http.Transformation|undefined} value */
proto.envoy.api.v2.filter.http.RouteTransformations.prototype.setResponseTransformation = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.envoy.api.v2.filter.http.RouteTransformations.prototype.clearResponseTransformation = function() {
  this.setResponseTransformation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.prototype.hasResponseTransformation = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool clear_route_cache = 3;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.prototype.getClearRouteCache = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 3, false));
};


/** @param {boolean} value */
proto.envoy.api.v2.filter.http.RouteTransformations.prototype.setClearRouteCache = function(value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * repeated RouteTransformation transformations = 4;
 * @return {!Array<!proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation>}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.prototype.getTransformationsList = function() {
  return /** @type{!Array<!proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation, 4));
};


/** @param {!Array<!proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation>} value */
proto.envoy.api.v2.filter.http.RouteTransformations.prototype.setTransformationsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation}
 */
proto.envoy.api.v2.filter.http.RouteTransformations.prototype.addTransformations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.envoy.api.v2.filter.http.RouteTransformations.RouteTransformation, opt_index);
};


proto.envoy.api.v2.filter.http.RouteTransformations.prototype.clearTransformationsList = function() {
  this.setTransformationsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.api.v2.filter.http.ResponseMatcher = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.envoy.api.v2.filter.http.ResponseMatcher.repeatedFields_, null);
};
goog.inherits(proto.envoy.api.v2.filter.http.ResponseMatcher, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.api.v2.filter.http.ResponseMatcher.displayName = 'proto.envoy.api.v2.filter.http.ResponseMatcher';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.envoy.api.v2.filter.http.ResponseMatcher.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.api.v2.filter.http.ResponseMatcher.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.api.v2.filter.http.ResponseMatcher.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.api.v2.filter.http.ResponseMatcher} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.ResponseMatcher.toObject = function(includeInstance, msg) {
  var f, obj = {
    headersList: jspb.Message.toObjectList(msg.getHeadersList(),
    github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_route_v3_route_components_pb.HeaderMatcher.toObject, includeInstance),
    responseCodeDetails: (f = msg.getResponseCodeDetails()) && github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_type_matcher_v3_string_pb.StringMatcher.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.api.v2.filter.http.ResponseMatcher}
 */
proto.envoy.api.v2.filter.http.ResponseMatcher.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.api.v2.filter.http.ResponseMatcher;
  return proto.envoy.api.v2.filter.http.ResponseMatcher.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.api.v2.filter.http.ResponseMatcher} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.api.v2.filter.http.ResponseMatcher}
 */
proto.envoy.api.v2.filter.http.ResponseMatcher.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_route_v3_route_components_pb.HeaderMatcher;
      reader.readMessage(value,github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_route_v3_route_components_pb.HeaderMatcher.deserializeBinaryFromReader);
      msg.addHeaders(value);
      break;
    case 2:
      var value = new github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_type_matcher_v3_string_pb.StringMatcher;
      reader.readMessage(value,github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_type_matcher_v3_string_pb.StringMatcher.deserializeBinaryFromReader);
      msg.setResponseCodeDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.api.v2.filter.http.ResponseMatcher.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.api.v2.filter.http.ResponseMatcher.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.api.v2.filter.http.ResponseMatcher} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.ResponseMatcher.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHeadersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_route_v3_route_components_pb.HeaderMatcher.serializeBinaryToWriter
    );
  }
  f = message.getResponseCodeDetails();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_type_matcher_v3_string_pb.StringMatcher.serializeBinaryToWriter
    );
  }
};


/**
 * repeated solo.io.envoy.config.route.v3.HeaderMatcher headers = 1;
 * @return {!Array<!proto.solo.io.envoy.config.route.v3.HeaderMatcher>}
 */
proto.envoy.api.v2.filter.http.ResponseMatcher.prototype.getHeadersList = function() {
  return /** @type{!Array<!proto.solo.io.envoy.config.route.v3.HeaderMatcher>} */ (
    jspb.Message.getRepeatedWrapperField(this, github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_route_v3_route_components_pb.HeaderMatcher, 1));
};


/** @param {!Array<!proto.solo.io.envoy.config.route.v3.HeaderMatcher>} value */
proto.envoy.api.v2.filter.http.ResponseMatcher.prototype.setHeadersList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.solo.io.envoy.config.route.v3.HeaderMatcher=} opt_value
 * @param {number=} opt_index
 * @return {!proto.solo.io.envoy.config.route.v3.HeaderMatcher}
 */
proto.envoy.api.v2.filter.http.ResponseMatcher.prototype.addHeaders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.solo.io.envoy.config.route.v3.HeaderMatcher, opt_index);
};


proto.envoy.api.v2.filter.http.ResponseMatcher.prototype.clearHeadersList = function() {
  this.setHeadersList([]);
};


/**
 * optional solo.io.envoy.type.matcher.v3.StringMatcher response_code_details = 2;
 * @return {?proto.solo.io.envoy.type.matcher.v3.StringMatcher}
 */
proto.envoy.api.v2.filter.http.ResponseMatcher.prototype.getResponseCodeDetails = function() {
  return /** @type{?proto.solo.io.envoy.type.matcher.v3.StringMatcher} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_type_matcher_v3_string_pb.StringMatcher, 2));
};


/** @param {?proto.solo.io.envoy.type.matcher.v3.StringMatcher|undefined} value */
proto.envoy.api.v2.filter.http.ResponseMatcher.prototype.setResponseCodeDetails = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.envoy.api.v2.filter.http.ResponseMatcher.prototype.clearResponseCodeDetails = function() {
  this.setResponseCodeDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.ResponseMatcher.prototype.hasResponseCodeDetails = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.api.v2.filter.http.ResponseTransformationRule = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.envoy.api.v2.filter.http.ResponseTransformationRule, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.api.v2.filter.http.ResponseTransformationRule.displayName = 'proto.envoy.api.v2.filter.http.ResponseTransformationRule';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.api.v2.filter.http.ResponseTransformationRule.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.api.v2.filter.http.ResponseTransformationRule.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.api.v2.filter.http.ResponseTransformationRule} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.ResponseTransformationRule.toObject = function(includeInstance, msg) {
  var f, obj = {
    match: (f = msg.getMatch()) && proto.envoy.api.v2.filter.http.ResponseMatcher.toObject(includeInstance, f),
    responseTransformation: (f = msg.getResponseTransformation()) && proto.envoy.api.v2.filter.http.Transformation.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.api.v2.filter.http.ResponseTransformationRule}
 */
proto.envoy.api.v2.filter.http.ResponseTransformationRule.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.api.v2.filter.http.ResponseTransformationRule;
  return proto.envoy.api.v2.filter.http.ResponseTransformationRule.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.api.v2.filter.http.ResponseTransformationRule} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.api.v2.filter.http.ResponseTransformationRule}
 */
proto.envoy.api.v2.filter.http.ResponseTransformationRule.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.envoy.api.v2.filter.http.ResponseMatcher;
      reader.readMessage(value,proto.envoy.api.v2.filter.http.ResponseMatcher.deserializeBinaryFromReader);
      msg.setMatch(value);
      break;
    case 2:
      var value = new proto.envoy.api.v2.filter.http.Transformation;
      reader.readMessage(value,proto.envoy.api.v2.filter.http.Transformation.deserializeBinaryFromReader);
      msg.setResponseTransformation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.api.v2.filter.http.ResponseTransformationRule.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.api.v2.filter.http.ResponseTransformationRule.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.api.v2.filter.http.ResponseTransformationRule} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.ResponseTransformationRule.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMatch();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.envoy.api.v2.filter.http.ResponseMatcher.serializeBinaryToWriter
    );
  }
  f = message.getResponseTransformation();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.envoy.api.v2.filter.http.Transformation.serializeBinaryToWriter
    );
  }
};


/**
 * optional ResponseMatcher match = 1;
 * @return {?proto.envoy.api.v2.filter.http.ResponseMatcher}
 */
proto.envoy.api.v2.filter.http.ResponseTransformationRule.prototype.getMatch = function() {
  return /** @type{?proto.envoy.api.v2.filter.http.ResponseMatcher} */ (
    jspb.Message.getWrapperField(this, proto.envoy.api.v2.filter.http.ResponseMatcher, 1));
};


/** @param {?proto.envoy.api.v2.filter.http.ResponseMatcher|undefined} value */
proto.envoy.api.v2.filter.http.ResponseTransformationRule.prototype.setMatch = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.envoy.api.v2.filter.http.ResponseTransformationRule.prototype.clearMatch = function() {
  this.setMatch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.ResponseTransformationRule.prototype.hasMatch = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Transformation response_transformation = 2;
 * @return {?proto.envoy.api.v2.filter.http.Transformation}
 */
proto.envoy.api.v2.filter.http.ResponseTransformationRule.prototype.getResponseTransformation = function() {
  return /** @type{?proto.envoy.api.v2.filter.http.Transformation} */ (
    jspb.Message.getWrapperField(this, proto.envoy.api.v2.filter.http.Transformation, 2));
};


/** @param {?proto.envoy.api.v2.filter.http.Transformation|undefined} value */
proto.envoy.api.v2.filter.http.ResponseTransformationRule.prototype.setResponseTransformation = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.envoy.api.v2.filter.http.ResponseTransformationRule.prototype.clearResponseTransformation = function() {
  this.setResponseTransformation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.ResponseTransformationRule.prototype.hasResponseTransformation = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.api.v2.filter.http.Transformation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.envoy.api.v2.filter.http.Transformation.oneofGroups_);
};
goog.inherits(proto.envoy.api.v2.filter.http.Transformation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.api.v2.filter.http.Transformation.displayName = 'proto.envoy.api.v2.filter.http.Transformation';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.envoy.api.v2.filter.http.Transformation.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.envoy.api.v2.filter.http.Transformation.TransformationTypeCase = {
  TRANSFORMATION_TYPE_NOT_SET: 0,
  TRANSFORMATION_TEMPLATE: 1,
  HEADER_BODY_TRANSFORM: 2,
  TRANSFORMER_CONFIG: 3
};

/**
 * @return {proto.envoy.api.v2.filter.http.Transformation.TransformationTypeCase}
 */
proto.envoy.api.v2.filter.http.Transformation.prototype.getTransformationTypeCase = function() {
  return /** @type {proto.envoy.api.v2.filter.http.Transformation.TransformationTypeCase} */(jspb.Message.computeOneofCase(this, proto.envoy.api.v2.filter.http.Transformation.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.api.v2.filter.http.Transformation.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.api.v2.filter.http.Transformation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.api.v2.filter.http.Transformation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.Transformation.toObject = function(includeInstance, msg) {
  var f, obj = {
    transformationTemplate: (f = msg.getTransformationTemplate()) && proto.envoy.api.v2.filter.http.TransformationTemplate.toObject(includeInstance, f),
    headerBodyTransform: (f = msg.getHeaderBodyTransform()) && proto.envoy.api.v2.filter.http.HeaderBodyTransform.toObject(includeInstance, f),
    transformerConfig: (f = msg.getTransformerConfig()) && github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_core_v3_extension_pb.TypedExtensionConfig.toObject(includeInstance, f),
    logRequestResponseInfo: (f = msg.getLogRequestResponseInfo()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.api.v2.filter.http.Transformation}
 */
proto.envoy.api.v2.filter.http.Transformation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.api.v2.filter.http.Transformation;
  return proto.envoy.api.v2.filter.http.Transformation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.api.v2.filter.http.Transformation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.api.v2.filter.http.Transformation}
 */
proto.envoy.api.v2.filter.http.Transformation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.envoy.api.v2.filter.http.TransformationTemplate;
      reader.readMessage(value,proto.envoy.api.v2.filter.http.TransformationTemplate.deserializeBinaryFromReader);
      msg.setTransformationTemplate(value);
      break;
    case 2:
      var value = new proto.envoy.api.v2.filter.http.HeaderBodyTransform;
      reader.readMessage(value,proto.envoy.api.v2.filter.http.HeaderBodyTransform.deserializeBinaryFromReader);
      msg.setHeaderBodyTransform(value);
      break;
    case 3:
      var value = new github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_core_v3_extension_pb.TypedExtensionConfig;
      reader.readMessage(value,github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_core_v3_extension_pb.TypedExtensionConfig.deserializeBinaryFromReader);
      msg.setTransformerConfig(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setLogRequestResponseInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.api.v2.filter.http.Transformation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.api.v2.filter.http.Transformation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.api.v2.filter.http.Transformation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.Transformation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransformationTemplate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.envoy.api.v2.filter.http.TransformationTemplate.serializeBinaryToWriter
    );
  }
  f = message.getHeaderBodyTransform();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.envoy.api.v2.filter.http.HeaderBodyTransform.serializeBinaryToWriter
    );
  }
  f = message.getTransformerConfig();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_core_v3_extension_pb.TypedExtensionConfig.serializeBinaryToWriter
    );
  }
  f = message.getLogRequestResponseInfo();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional TransformationTemplate transformation_template = 1;
 * @return {?proto.envoy.api.v2.filter.http.TransformationTemplate}
 */
proto.envoy.api.v2.filter.http.Transformation.prototype.getTransformationTemplate = function() {
  return /** @type{?proto.envoy.api.v2.filter.http.TransformationTemplate} */ (
    jspb.Message.getWrapperField(this, proto.envoy.api.v2.filter.http.TransformationTemplate, 1));
};


/** @param {?proto.envoy.api.v2.filter.http.TransformationTemplate|undefined} value */
proto.envoy.api.v2.filter.http.Transformation.prototype.setTransformationTemplate = function(value) {
  jspb.Message.setOneofWrapperField(this, 1, proto.envoy.api.v2.filter.http.Transformation.oneofGroups_[0], value);
};


proto.envoy.api.v2.filter.http.Transformation.prototype.clearTransformationTemplate = function() {
  this.setTransformationTemplate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.Transformation.prototype.hasTransformationTemplate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional HeaderBodyTransform header_body_transform = 2;
 * @return {?proto.envoy.api.v2.filter.http.HeaderBodyTransform}
 */
proto.envoy.api.v2.filter.http.Transformation.prototype.getHeaderBodyTransform = function() {
  return /** @type{?proto.envoy.api.v2.filter.http.HeaderBodyTransform} */ (
    jspb.Message.getWrapperField(this, proto.envoy.api.v2.filter.http.HeaderBodyTransform, 2));
};


/** @param {?proto.envoy.api.v2.filter.http.HeaderBodyTransform|undefined} value */
proto.envoy.api.v2.filter.http.Transformation.prototype.setHeaderBodyTransform = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.envoy.api.v2.filter.http.Transformation.oneofGroups_[0], value);
};


proto.envoy.api.v2.filter.http.Transformation.prototype.clearHeaderBodyTransform = function() {
  this.setHeaderBodyTransform(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.Transformation.prototype.hasHeaderBodyTransform = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional solo.io.envoy.config.core.v3.TypedExtensionConfig transformer_config = 3;
 * @return {?proto.solo.io.envoy.config.core.v3.TypedExtensionConfig}
 */
proto.envoy.api.v2.filter.http.Transformation.prototype.getTransformerConfig = function() {
  return /** @type{?proto.solo.io.envoy.config.core.v3.TypedExtensionConfig} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_core_v3_extension_pb.TypedExtensionConfig, 3));
};


/** @param {?proto.solo.io.envoy.config.core.v3.TypedExtensionConfig|undefined} value */
proto.envoy.api.v2.filter.http.Transformation.prototype.setTransformerConfig = function(value) {
  jspb.Message.setOneofWrapperField(this, 3, proto.envoy.api.v2.filter.http.Transformation.oneofGroups_[0], value);
};


proto.envoy.api.v2.filter.http.Transformation.prototype.clearTransformerConfig = function() {
  this.setTransformerConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.Transformation.prototype.hasTransformerConfig = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.BoolValue log_request_response_info = 4;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.envoy.api.v2.filter.http.Transformation.prototype.getLogRequestResponseInfo = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 4));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.envoy.api.v2.filter.http.Transformation.prototype.setLogRequestResponseInfo = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


proto.envoy.api.v2.filter.http.Transformation.prototype.clearLogRequestResponseInfo = function() {
  this.setLogRequestResponseInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.Transformation.prototype.hasLogRequestResponseInfo = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.api.v2.filter.http.Extraction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.envoy.api.v2.filter.http.Extraction.oneofGroups_);
};
goog.inherits(proto.envoy.api.v2.filter.http.Extraction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.api.v2.filter.http.Extraction.displayName = 'proto.envoy.api.v2.filter.http.Extraction';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.envoy.api.v2.filter.http.Extraction.oneofGroups_ = [[1,4]];

/**
 * @enum {number}
 */
proto.envoy.api.v2.filter.http.Extraction.SourceCase = {
  SOURCE_NOT_SET: 0,
  HEADER: 1,
  BODY: 4
};

/**
 * @return {proto.envoy.api.v2.filter.http.Extraction.SourceCase}
 */
proto.envoy.api.v2.filter.http.Extraction.prototype.getSourceCase = function() {
  return /** @type {proto.envoy.api.v2.filter.http.Extraction.SourceCase} */(jspb.Message.computeOneofCase(this, proto.envoy.api.v2.filter.http.Extraction.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.api.v2.filter.http.Extraction.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.api.v2.filter.http.Extraction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.api.v2.filter.http.Extraction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.Extraction.toObject = function(includeInstance, msg) {
  var f, obj = {
    header: jspb.Message.getFieldWithDefault(msg, 1, ""),
    body: (f = msg.getBody()) && google_protobuf_empty_pb.Empty.toObject(includeInstance, f),
    regex: jspb.Message.getFieldWithDefault(msg, 2, ""),
    subgroup: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.api.v2.filter.http.Extraction}
 */
proto.envoy.api.v2.filter.http.Extraction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.api.v2.filter.http.Extraction;
  return proto.envoy.api.v2.filter.http.Extraction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.api.v2.filter.http.Extraction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.api.v2.filter.http.Extraction}
 */
proto.envoy.api.v2.filter.http.Extraction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHeader(value);
      break;
    case 4:
      var value = new google_protobuf_empty_pb.Empty;
      reader.readMessage(value,google_protobuf_empty_pb.Empty.deserializeBinaryFromReader);
      msg.setBody(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegex(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSubgroup(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.api.v2.filter.http.Extraction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.api.v2.filter.http.Extraction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.api.v2.filter.http.Extraction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.Extraction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBody();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_empty_pb.Empty.serializeBinaryToWriter
    );
  }
  f = message.getRegex();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSubgroup();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional string header = 1;
 * @return {string}
 */
proto.envoy.api.v2.filter.http.Extraction.prototype.getHeader = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.envoy.api.v2.filter.http.Extraction.prototype.setHeader = function(value) {
  jspb.Message.setOneofField(this, 1, proto.envoy.api.v2.filter.http.Extraction.oneofGroups_[0], value);
};


proto.envoy.api.v2.filter.http.Extraction.prototype.clearHeader = function() {
  jspb.Message.setOneofField(this, 1, proto.envoy.api.v2.filter.http.Extraction.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.Extraction.prototype.hasHeader = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Empty body = 4;
 * @return {?proto.google.protobuf.Empty}
 */
proto.envoy.api.v2.filter.http.Extraction.prototype.getBody = function() {
  return /** @type{?proto.google.protobuf.Empty} */ (
    jspb.Message.getWrapperField(this, google_protobuf_empty_pb.Empty, 4));
};


/** @param {?proto.google.protobuf.Empty|undefined} value */
proto.envoy.api.v2.filter.http.Extraction.prototype.setBody = function(value) {
  jspb.Message.setOneofWrapperField(this, 4, proto.envoy.api.v2.filter.http.Extraction.oneofGroups_[0], value);
};


proto.envoy.api.v2.filter.http.Extraction.prototype.clearBody = function() {
  this.setBody(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.Extraction.prototype.hasBody = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string regex = 2;
 * @return {string}
 */
proto.envoy.api.v2.filter.http.Extraction.prototype.getRegex = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.envoy.api.v2.filter.http.Extraction.prototype.setRegex = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 subgroup = 3;
 * @return {number}
 */
proto.envoy.api.v2.filter.http.Extraction.prototype.getSubgroup = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.envoy.api.v2.filter.http.Extraction.prototype.setSubgroup = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.api.v2.filter.http.TransformationTemplate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.envoy.api.v2.filter.http.TransformationTemplate.repeatedFields_, proto.envoy.api.v2.filter.http.TransformationTemplate.oneofGroups_);
};
goog.inherits(proto.envoy.api.v2.filter.http.TransformationTemplate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.api.v2.filter.http.TransformationTemplate.displayName = 'proto.envoy.api.v2.filter.http.TransformationTemplate';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.repeatedFields_ = [10,11,9];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.oneofGroups_ = [[4,5,6]];

/**
 * @enum {number}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.BodyTransformationCase = {
  BODY_TRANSFORMATION_NOT_SET: 0,
  BODY: 4,
  PASSTHROUGH: 5,
  MERGE_EXTRACTORS_TO_BODY: 6
};

/**
 * @return {proto.envoy.api.v2.filter.http.TransformationTemplate.BodyTransformationCase}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.getBodyTransformationCase = function() {
  return /** @type {proto.envoy.api.v2.filter.http.TransformationTemplate.BodyTransformationCase} */(jspb.Message.computeOneofCase(this, proto.envoy.api.v2.filter.http.TransformationTemplate.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.api.v2.filter.http.TransformationTemplate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.api.v2.filter.http.TransformationTemplate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.toObject = function(includeInstance, msg) {
  var f, obj = {
    advancedTemplates: jspb.Message.getFieldWithDefault(msg, 1, false),
    extractorsMap: (f = msg.getExtractorsMap()) ? f.toObject(includeInstance, proto.envoy.api.v2.filter.http.Extraction.toObject) : [],
    headersMap: (f = msg.getHeadersMap()) ? f.toObject(includeInstance, proto.envoy.api.v2.filter.http.InjaTemplate.toObject) : [],
    headersToAppendList: jspb.Message.toObjectList(msg.getHeadersToAppendList(),
    proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend.toObject, includeInstance),
    headersToRemoveList: jspb.Message.getRepeatedField(msg, 11),
    body: (f = msg.getBody()) && proto.envoy.api.v2.filter.http.InjaTemplate.toObject(includeInstance, f),
    passthrough: (f = msg.getPassthrough()) && proto.envoy.api.v2.filter.http.Passthrough.toObject(includeInstance, f),
    mergeExtractorsToBody: (f = msg.getMergeExtractorsToBody()) && proto.envoy.api.v2.filter.http.MergeExtractorsToBody.toObject(includeInstance, f),
    parseBodyBehavior: jspb.Message.getFieldWithDefault(msg, 7, 0),
    ignoreErrorOnParse: jspb.Message.getFieldWithDefault(msg, 8, false),
    dynamicMetadataValuesList: jspb.Message.toObjectList(msg.getDynamicMetadataValuesList(),
    proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue.toObject, includeInstance),
    escapeCharacters: jspb.Message.getFieldWithDefault(msg, 12, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.api.v2.filter.http.TransformationTemplate}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.api.v2.filter.http.TransformationTemplate;
  return proto.envoy.api.v2.filter.http.TransformationTemplate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.api.v2.filter.http.TransformationTemplate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.api.v2.filter.http.TransformationTemplate}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAdvancedTemplates(value);
      break;
    case 2:
      var value = msg.getExtractorsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.envoy.api.v2.filter.http.Extraction.deserializeBinaryFromReader, "");
         });
      break;
    case 3:
      var value = msg.getHeadersMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.envoy.api.v2.filter.http.InjaTemplate.deserializeBinaryFromReader, "");
         });
      break;
    case 10:
      var value = new proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend;
      reader.readMessage(value,proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend.deserializeBinaryFromReader);
      msg.addHeadersToAppend(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.addHeadersToRemove(value);
      break;
    case 4:
      var value = new proto.envoy.api.v2.filter.http.InjaTemplate;
      reader.readMessage(value,proto.envoy.api.v2.filter.http.InjaTemplate.deserializeBinaryFromReader);
      msg.setBody(value);
      break;
    case 5:
      var value = new proto.envoy.api.v2.filter.http.Passthrough;
      reader.readMessage(value,proto.envoy.api.v2.filter.http.Passthrough.deserializeBinaryFromReader);
      msg.setPassthrough(value);
      break;
    case 6:
      var value = new proto.envoy.api.v2.filter.http.MergeExtractorsToBody;
      reader.readMessage(value,proto.envoy.api.v2.filter.http.MergeExtractorsToBody.deserializeBinaryFromReader);
      msg.setMergeExtractorsToBody(value);
      break;
    case 7:
      var value = /** @type {!proto.envoy.api.v2.filter.http.TransformationTemplate.RequestBodyParse} */ (reader.readEnum());
      msg.setParseBodyBehavior(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIgnoreErrorOnParse(value);
      break;
    case 9:
      var value = new proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue;
      reader.readMessage(value,proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue.deserializeBinaryFromReader);
      msg.addDynamicMetadataValues(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEscapeCharacters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.api.v2.filter.http.TransformationTemplate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.api.v2.filter.http.TransformationTemplate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAdvancedTemplates();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getExtractorsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.envoy.api.v2.filter.http.Extraction.serializeBinaryToWriter);
  }
  f = message.getHeadersMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.envoy.api.v2.filter.http.InjaTemplate.serializeBinaryToWriter);
  }
  f = message.getHeadersToAppendList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend.serializeBinaryToWriter
    );
  }
  f = message.getHeadersToRemoveList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      11,
      f
    );
  }
  f = message.getBody();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.envoy.api.v2.filter.http.InjaTemplate.serializeBinaryToWriter
    );
  }
  f = message.getPassthrough();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.envoy.api.v2.filter.http.Passthrough.serializeBinaryToWriter
    );
  }
  f = message.getMergeExtractorsToBody();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.envoy.api.v2.filter.http.MergeExtractorsToBody.serializeBinaryToWriter
    );
  }
  f = message.getParseBodyBehavior();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getIgnoreErrorOnParse();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getDynamicMetadataValuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue.serializeBinaryToWriter
    );
  }
  f = message.getEscapeCharacters();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.RequestBodyParse = {
  PARSEASJSON: 0,
  DONTPARSE: 1
};


/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend.displayName = 'proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend.toObject = function(includeInstance, msg) {
  var f, obj = {
    key: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: (f = msg.getValue()) && proto.envoy.api.v2.filter.http.InjaTemplate.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend;
  return proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = new proto.envoy.api.v2.filter.http.InjaTemplate;
      reader.readMessage(value,proto.envoy.api.v2.filter.http.InjaTemplate.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.envoy.api.v2.filter.http.InjaTemplate.serializeBinaryToWriter
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend.prototype.setKey = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional InjaTemplate value = 2;
 * @return {?proto.envoy.api.v2.filter.http.InjaTemplate}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend.prototype.getValue = function() {
  return /** @type{?proto.envoy.api.v2.filter.http.InjaTemplate} */ (
    jspb.Message.getWrapperField(this, proto.envoy.api.v2.filter.http.InjaTemplate, 2));
};


/** @param {?proto.envoy.api.v2.filter.http.InjaTemplate|undefined} value */
proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend.prototype.setValue = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend.prototype.clearValue = function() {
  this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend.prototype.hasValue = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue.displayName = 'proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    metadataNamespace: jspb.Message.getFieldWithDefault(msg, 1, ""),
    key: jspb.Message.getFieldWithDefault(msg, 2, ""),
    value: (f = msg.getValue()) && proto.envoy.api.v2.filter.http.InjaTemplate.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue;
  return proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMetadataNamespace(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 3:
      var value = new proto.envoy.api.v2.filter.http.InjaTemplate;
      reader.readMessage(value,proto.envoy.api.v2.filter.http.InjaTemplate.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetadataNamespace();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.envoy.api.v2.filter.http.InjaTemplate.serializeBinaryToWriter
    );
  }
};


/**
 * optional string metadata_namespace = 1;
 * @return {string}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue.prototype.getMetadataNamespace = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue.prototype.setMetadataNamespace = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string key = 2;
 * @return {string}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue.prototype.setKey = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional InjaTemplate value = 3;
 * @return {?proto.envoy.api.v2.filter.http.InjaTemplate}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue.prototype.getValue = function() {
  return /** @type{?proto.envoy.api.v2.filter.http.InjaTemplate} */ (
    jspb.Message.getWrapperField(this, proto.envoy.api.v2.filter.http.InjaTemplate, 3));
};


/** @param {?proto.envoy.api.v2.filter.http.InjaTemplate|undefined} value */
proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue.prototype.setValue = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue.prototype.clearValue = function() {
  this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue.prototype.hasValue = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool advanced_templates = 1;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.getAdvancedTemplates = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 1, false));
};


/** @param {boolean} value */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.setAdvancedTemplates = function(value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * map<string, Extraction> extractors = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.envoy.api.v2.filter.http.Extraction>}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.getExtractorsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.envoy.api.v2.filter.http.Extraction>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      proto.envoy.api.v2.filter.http.Extraction));
};


proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.clearExtractorsMap = function() {
  this.getExtractorsMap().clear();
};


/**
 * map<string, InjaTemplate> headers = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.envoy.api.v2.filter.http.InjaTemplate>}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.getHeadersMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.envoy.api.v2.filter.http.InjaTemplate>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      proto.envoy.api.v2.filter.http.InjaTemplate));
};


proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.clearHeadersMap = function() {
  this.getHeadersMap().clear();
};


/**
 * repeated HeaderToAppend headers_to_append = 10;
 * @return {!Array<!proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend>}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.getHeadersToAppendList = function() {
  return /** @type{!Array<!proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend, 10));
};


/** @param {!Array<!proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend>} value */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.setHeadersToAppendList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend=} opt_value
 * @param {number=} opt_index
 * @return {!proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.addHeadersToAppend = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.envoy.api.v2.filter.http.TransformationTemplate.HeaderToAppend, opt_index);
};


proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.clearHeadersToAppendList = function() {
  this.setHeadersToAppendList([]);
};


/**
 * repeated string headers_to_remove = 11;
 * @return {!Array<string>}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.getHeadersToRemoveList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 11));
};


/** @param {!Array<string>} value */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.setHeadersToRemoveList = function(value) {
  jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.addHeadersToRemove = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.clearHeadersToRemoveList = function() {
  this.setHeadersToRemoveList([]);
};


/**
 * optional InjaTemplate body = 4;
 * @return {?proto.envoy.api.v2.filter.http.InjaTemplate}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.getBody = function() {
  return /** @type{?proto.envoy.api.v2.filter.http.InjaTemplate} */ (
    jspb.Message.getWrapperField(this, proto.envoy.api.v2.filter.http.InjaTemplate, 4));
};


/** @param {?proto.envoy.api.v2.filter.http.InjaTemplate|undefined} value */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.setBody = function(value) {
  jspb.Message.setOneofWrapperField(this, 4, proto.envoy.api.v2.filter.http.TransformationTemplate.oneofGroups_[0], value);
};


proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.clearBody = function() {
  this.setBody(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.hasBody = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Passthrough passthrough = 5;
 * @return {?proto.envoy.api.v2.filter.http.Passthrough}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.getPassthrough = function() {
  return /** @type{?proto.envoy.api.v2.filter.http.Passthrough} */ (
    jspb.Message.getWrapperField(this, proto.envoy.api.v2.filter.http.Passthrough, 5));
};


/** @param {?proto.envoy.api.v2.filter.http.Passthrough|undefined} value */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.setPassthrough = function(value) {
  jspb.Message.setOneofWrapperField(this, 5, proto.envoy.api.v2.filter.http.TransformationTemplate.oneofGroups_[0], value);
};


proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.clearPassthrough = function() {
  this.setPassthrough(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.hasPassthrough = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional MergeExtractorsToBody merge_extractors_to_body = 6;
 * @return {?proto.envoy.api.v2.filter.http.MergeExtractorsToBody}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.getMergeExtractorsToBody = function() {
  return /** @type{?proto.envoy.api.v2.filter.http.MergeExtractorsToBody} */ (
    jspb.Message.getWrapperField(this, proto.envoy.api.v2.filter.http.MergeExtractorsToBody, 6));
};


/** @param {?proto.envoy.api.v2.filter.http.MergeExtractorsToBody|undefined} value */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.setMergeExtractorsToBody = function(value) {
  jspb.Message.setOneofWrapperField(this, 6, proto.envoy.api.v2.filter.http.TransformationTemplate.oneofGroups_[0], value);
};


proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.clearMergeExtractorsToBody = function() {
  this.setMergeExtractorsToBody(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.hasMergeExtractorsToBody = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional RequestBodyParse parse_body_behavior = 7;
 * @return {!proto.envoy.api.v2.filter.http.TransformationTemplate.RequestBodyParse}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.getParseBodyBehavior = function() {
  return /** @type {!proto.envoy.api.v2.filter.http.TransformationTemplate.RequestBodyParse} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {!proto.envoy.api.v2.filter.http.TransformationTemplate.RequestBodyParse} value */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.setParseBodyBehavior = function(value) {
  jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional bool ignore_error_on_parse = 8;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.getIgnoreErrorOnParse = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 8, false));
};


/** @param {boolean} value */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.setIgnoreErrorOnParse = function(value) {
  jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * repeated DynamicMetadataValue dynamic_metadata_values = 9;
 * @return {!Array<!proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue>}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.getDynamicMetadataValuesList = function() {
  return /** @type{!Array<!proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue, 9));
};


/** @param {!Array<!proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue>} value */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.setDynamicMetadataValuesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.addDynamicMetadataValues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.envoy.api.v2.filter.http.TransformationTemplate.DynamicMetadataValue, opt_index);
};


proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.clearDynamicMetadataValuesList = function() {
  this.setDynamicMetadataValuesList([]);
};


/**
 * optional bool escape_characters = 12;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.getEscapeCharacters = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 12, false));
};


/** @param {boolean} value */
proto.envoy.api.v2.filter.http.TransformationTemplate.prototype.setEscapeCharacters = function(value) {
  jspb.Message.setProto3BooleanField(this, 12, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.api.v2.filter.http.InjaTemplate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.envoy.api.v2.filter.http.InjaTemplate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.api.v2.filter.http.InjaTemplate.displayName = 'proto.envoy.api.v2.filter.http.InjaTemplate';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.api.v2.filter.http.InjaTemplate.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.api.v2.filter.http.InjaTemplate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.api.v2.filter.http.InjaTemplate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.InjaTemplate.toObject = function(includeInstance, msg) {
  var f, obj = {
    text: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.api.v2.filter.http.InjaTemplate}
 */
proto.envoy.api.v2.filter.http.InjaTemplate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.api.v2.filter.http.InjaTemplate;
  return proto.envoy.api.v2.filter.http.InjaTemplate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.api.v2.filter.http.InjaTemplate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.api.v2.filter.http.InjaTemplate}
 */
proto.envoy.api.v2.filter.http.InjaTemplate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.api.v2.filter.http.InjaTemplate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.api.v2.filter.http.InjaTemplate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.api.v2.filter.http.InjaTemplate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.InjaTemplate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string text = 1;
 * @return {string}
 */
proto.envoy.api.v2.filter.http.InjaTemplate.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.envoy.api.v2.filter.http.InjaTemplate.prototype.setText = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.api.v2.filter.http.Passthrough = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.envoy.api.v2.filter.http.Passthrough, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.api.v2.filter.http.Passthrough.displayName = 'proto.envoy.api.v2.filter.http.Passthrough';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.api.v2.filter.http.Passthrough.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.api.v2.filter.http.Passthrough.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.api.v2.filter.http.Passthrough} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.Passthrough.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.api.v2.filter.http.Passthrough}
 */
proto.envoy.api.v2.filter.http.Passthrough.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.api.v2.filter.http.Passthrough;
  return proto.envoy.api.v2.filter.http.Passthrough.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.api.v2.filter.http.Passthrough} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.api.v2.filter.http.Passthrough}
 */
proto.envoy.api.v2.filter.http.Passthrough.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.api.v2.filter.http.Passthrough.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.api.v2.filter.http.Passthrough.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.api.v2.filter.http.Passthrough} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.Passthrough.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.api.v2.filter.http.MergeExtractorsToBody = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.envoy.api.v2.filter.http.MergeExtractorsToBody, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.api.v2.filter.http.MergeExtractorsToBody.displayName = 'proto.envoy.api.v2.filter.http.MergeExtractorsToBody';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.api.v2.filter.http.MergeExtractorsToBody.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.api.v2.filter.http.MergeExtractorsToBody.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.api.v2.filter.http.MergeExtractorsToBody} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.MergeExtractorsToBody.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.api.v2.filter.http.MergeExtractorsToBody}
 */
proto.envoy.api.v2.filter.http.MergeExtractorsToBody.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.api.v2.filter.http.MergeExtractorsToBody;
  return proto.envoy.api.v2.filter.http.MergeExtractorsToBody.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.api.v2.filter.http.MergeExtractorsToBody} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.api.v2.filter.http.MergeExtractorsToBody}
 */
proto.envoy.api.v2.filter.http.MergeExtractorsToBody.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.api.v2.filter.http.MergeExtractorsToBody.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.api.v2.filter.http.MergeExtractorsToBody.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.api.v2.filter.http.MergeExtractorsToBody} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.MergeExtractorsToBody.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.api.v2.filter.http.HeaderBodyTransform = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.envoy.api.v2.filter.http.HeaderBodyTransform, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.api.v2.filter.http.HeaderBodyTransform.displayName = 'proto.envoy.api.v2.filter.http.HeaderBodyTransform';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.api.v2.filter.http.HeaderBodyTransform.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.api.v2.filter.http.HeaderBodyTransform.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.api.v2.filter.http.HeaderBodyTransform} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.HeaderBodyTransform.toObject = function(includeInstance, msg) {
  var f, obj = {
    addRequestMetadata: jspb.Message.getFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.api.v2.filter.http.HeaderBodyTransform}
 */
proto.envoy.api.v2.filter.http.HeaderBodyTransform.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.api.v2.filter.http.HeaderBodyTransform;
  return proto.envoy.api.v2.filter.http.HeaderBodyTransform.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.api.v2.filter.http.HeaderBodyTransform} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.api.v2.filter.http.HeaderBodyTransform}
 */
proto.envoy.api.v2.filter.http.HeaderBodyTransform.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAddRequestMetadata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.api.v2.filter.http.HeaderBodyTransform.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.api.v2.filter.http.HeaderBodyTransform.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.api.v2.filter.http.HeaderBodyTransform} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.filter.http.HeaderBodyTransform.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddRequestMetadata();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool add_request_metadata = 1;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.envoy.api.v2.filter.http.HeaderBodyTransform.prototype.getAddRequestMetadata = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 1, false));
};


/** @param {boolean} value */
proto.envoy.api.v2.filter.http.HeaderBodyTransform.prototype.setAddRequestMetadata = function(value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};


goog.object.extend(exports, proto.envoy.api.v2.filter.http);
